// components/SnipcartConsentWrapper.tsx
'use client';

import { useCookieConsent } from '@lightwaves/hooks';
import Snipcart from "@/components/snipcart";

export function SnipcartConsentWrapper() {
  const { hasConsent } = useCookieConsent();

  // If the user has not accepted, or hasn't made a choice yet, don't load Snipcart
  if (hasConsent !== true) {
    return null;
  }

  return <Snipcart />;
}
